import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose } from 'recompose';
import DataTable from './DataTable';
import { getDataTableConfiguration, getDataTableSelected, getDataTableAll, setColumnConfig, setSelected, setSelectedAll, } from './store';
const mapStateToProps = (state, props) => {
    return {
        storedColumns: getDataTableConfiguration(state.dataTable, props.tableId),
        selected: getDataTableSelected(state.dataTable, props.tableId),
        selectedAll: getDataTableAll(state.dataTable, props.tableId),
    };
};
const mapDispatchToProps = (dispatch, props) => bindActionCreators({
    setColumnConfig: (columnId, columnConfig) => setColumnConfig({
        tableId: props.tableId,
        column: {
            config: columnConfig,
            id: columnId,
        },
    }),
    setSelectedItems: (selectedItems) => setSelected({
        tableId: props.tableId,
        selected: selectedItems,
    }),
    setSelectedAll: (all) => setSelectedAll({
        tableId: props.tableId,
        all,
    }),
}, dispatch);
export default compose(connect(mapStateToProps, mapDispatchToProps))(DataTable);
//# sourceMappingURL=DataTableContainer.js.map